var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7493 15.1265C12.9021 14.9737 12.9785 14.7793 12.9785 14.5432C12.9785 14.3071 12.9021 14.1126 12.7493 13.9598L9.49927 10.7098L12.7493 7.45983C12.9021 7.30705 12.9785 7.11261 12.9785 6.8765C12.9785 6.64038 12.9021 6.44594 12.7493 6.29316C12.5965 6.14038 12.4021 6.064 12.166 6.064C11.9299 6.064 11.7355 6.14038 11.5827 6.29316L7.74927 10.1265C7.66694 10.2098 7.6077 10.3001 7.57269 10.3973C7.5383 10.4946 7.52109 10.5987 7.52109 10.7098C7.52109 10.8209 7.5383 10.9251 7.57269 11.0223C7.6077 11.1196 7.66694 11.2098 7.74927 11.2932L11.5827 15.1265C11.7355 15.2793 11.9299 15.3557 12.166 15.3557C12.4021 15.3557 12.5965 15.2793 12.7493 15.1265Z",
    fill: "#212529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.f7fe5273c75570bde76143978b822f39.svg";
export { ForwardRef as ReactComponent };